import { FETCH_API_DATA_SUCCESS, SET_LOADING } from '../actions/DashboardActions';

const initialState = {
  apiData: null 
};

const DashboardReducer = function (state = initialState, action) {
  switch (action.type) {
    case FETCH_API_DATA_SUCCESS:
      return {
        ...state,
        apiData: action.payload,
      };
      case SET_LOADING:
      return {
        ...state,
        pageLoading: action.payload,
      };
    default: {
      return {...state};
    }
  }
};

export default DashboardReducer;
